import { useRef, useState, useEffect } from 'react';
import TextBoxControl from "../../../../Controls/TextBoxControl"
import GridControl from "../../../../Controls/GridControl"
import Accordion from 'react-bootstrap/Accordion';
import ShowOwnerResidentialInfo from "../../../../Controls/ShowOwnerResidentialInfo"
import ShowFilesReviewAbstractList from "../../../../Controls/ShowFilesReviewAbstractList"

import { 
	GetLocal,
	FetchService,
	Base64Type
} from "../../../../Base/BaseControl";
import { EmployeeSessionCheckFetch } from '../../../../Base/BasePageEmployee';

export default function Index(props) {
	const [getServiceResult, setServiceResult] = useState(false);
	
    useEffect(() => {
        var inputValue = {
             session: GetLocal('EmployeeSession'),
			 fileNumber: GetLocal('FileNumber')
        };
        EmployeeSessionCheckFetch("Employee/Urbanization/Review/ShowCreateFileReview", inputValue, ShowServiceResultSuccess);
    }, []);	
	
    const ShowServiceResultSuccess = (ServiceResult) => {
		setServiceResult(ServiceResult);
    }		
	
    return (
        <div> 
			<ShowOwnerResidentialInfo Session={GetLocal('EmployeeSession')}/>
			<ShowFilesReviewAbstractList/>
			{getServiceResult ? <div>
			<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
				<tbody>
						<tr>
							<td><b class="b1">شماره پرونده:</b> {getServiceResult.FileNumber}</td>
							<td><b class="b1">کد نوسازی:</b> 
								{getServiceResult.Apartment}
								 -  {getServiceResult.Parcel}
								 -  {getServiceResult.Block}
								 -  {getServiceResult.District}
								 -  {getServiceResult.Area}		
							 </td>
							<td><b class="b1">نوع سند مالکیت:</b> {getServiceResult.DocumentTitle}</td>
						</tr>
						<tr>	
							<td><b class="b1">بخش ثبتی:</b>{getServiceResult.RegistrationDepartment}</td>
							<td><b class="b1">مساحت:</b> {getServiceResult.AreaByDocument}</td>
							<td><b class="b1">پلاک آبی:</b> {getServiceResult.HomeNumber}</td>
						</tr>
						<tr>	
							<td><b class="b1">کد پستی:</b> {getServiceResult.PostalCode}</td>	
							<td><b class="b1">نشانی مالک:</b> {getServiceResult.Address}</td>
							<td colspan="1"><b class="b1">ملک قبلی:</b> {getServiceResult.PreviousParcel}</td>
						</tr>
						<tr>							
							<td colspan="3"><b class="b1">توضیحات:</b> {getServiceResult.Description}</td>
						</tr>
				</tbody>	
			</table>	
			<br/>
			<GridControl
				data={Object.keys(getServiceResult).length > 0 && getServiceResult.RegistrationPlateInfoList}
				customHeaders={{
					"Description": "توضیحات",
					"ParcelCode": "قطعه",
					"SecondaryCode": "فرعی",
					"PrimaryCode": "اصلی"
				}}		
			/>				
			<br/>
			<GridControl
				data={Object.keys(getServiceResult).length > 0 && getServiceResult.DimentionDetailsInfoList}
				customHeaders={{
					"DimensionsSide": "جهت",
					"LengthSide": "طول ضلع",
					"LimitTitle": "حد",
					"CrossWidth": "عرض گذر",
					"StreetName": "نام معبر",
					"Description": "توضیحات"
				}}		
			/>				
			<br/>
			<table className="table table-bordered table-striped tblbg" cellspacing="0" cellpadding="0" style={{ width: '100%' }}>
				<tbody>
					<tr>
						<td><b class="b1">معبر وقوع:</b> {getServiceResult.StreetName}</td>
						<td><b class="b1">طبقه وقوع:</b> {getServiceResult.BuildingFloorDescription}</td>
						<td><b class="b1">جهت آپارتمان:</b> {getServiceResult.Direction}</td>
					</tr>
					<tr>	
						<td><b class="b1">حقوق ارتفاعی:</b> {getServiceResult.LegalDescription}</td>
						<td><b class="b1">شماره پرونده مادر:</b> {getServiceResult.MainFileNumber}</td>
					</tr>		
				</tbody>
			</table>				
        </div>
		:
			<div className="alert alert-danger text-center">موردی یافت نشد.</div>
		}
		</div>	
    );
}
